<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
      <v-spacer></v-spacer>
      <v-dialog v-model="servicePriceEditorDialog">
        <v-btn slot="activator" class="mb-2">Create New Price</v-btn>
        <service-price-list-item-form
          :price="selectedPrice"
          @onCancel="onPriceEditCancel($event)"
          @onSave="onPriceEditSave($event)"
        ></service-price-list-item-form>
      </v-dialog>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="servicePrices.edges"
        :loading="$apollo.loading"
        class="elevation-1"
        v-bind="pagingOptions"
      >
        <template slot="items" slot-scope="props">
          <td class="text-right">{{ props.item.node.dateFrom | formatDate }}</td>
          <td class="text-right">{{ props.item.node.dateTo | formatDate }}</td>
          <td class="text-right">{{ props.item.node.rateTypeCode }}</td>
          <td class="text-right">{{ props.item.node.currencyCodeBuy }}</td>
          <td class="text-right">{{ props.item.node.adultBuy1 }}</td>
          <td class="text-right">{{ props.item.node.currencyCodeSell }}</td>
          <td class="text-right">{{ props.item.node.adultSell1 }}</td>
          <td class="text-right">
            <v-btn icon class="mx-0" @click="editPrice(props.item)">
              <v-tooltip bottom>
                <v-icon color="teal" slot="activator">edit</v-icon>
                <span>Edit Price</span>
              </v-tooltip>
            </v-btn>
            <confirmation-dialog @onConfirm="onRemovePrice" :item="props.item">
              <v-btn icon class="mx-0">
                <v-tooltip bottom>
                  <v-icon color="pink" slot="activator">delete</v-icon>
                  <span>Remove Price</span>
                </v-tooltip>
              </v-btn>
            </confirmation-dialog>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="$emit('onCancel')">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  ALL_SERVICE_PRICES_QUERY,
  SERVICE_PRICE_UPDATE_MUTATION,
  SERVICE_PRICE_CREATE_MUTATION,
  SERVICE_PRICE_DELETE_MUTATION
} from "../../../../../constants/graphql";
import { sortByDate, pagingOptions } from "../../../../../helpers/index";

let moment = require("moment");
import ServicePriceListItemForm from "./ServicePriceListItemForm";
import ConfirmationDialog from "../../../shared/ConfirmationDialog";
import EventBus from "../../../../../store/event-bus";

const datePickerFormat = "YYYY-MM-DD";
export default {
  name: "ServicePriceList",
  props: {
    service: {
      type: Object
    }
  },
  components: {
    ServicePriceListItemForm,
    ConfirmationDialog
  },
  data() {
    return {
      pagingOptions,
      prices: [],
      servicePrices: {},
      servicePriceEditorDialog: false,
      defaultPrice: {
        dateFrom: moment().toISOString(true),
        dateTo: moment()
          .add(30, "days")
          .toISOString(true),
        rateTypeCode: "",
        currencyCodeBuy: "",
        currencyCodeSell: "",
        adultBuy1: 0,
        adultSell1: 0,
        id: null
      },
      selectedPrice: {
        dateFrom: moment().toISOString(true),
        dateTo: moment()
          .add(30, "days")
          .toISOString(true),
        rateTypeCode: "",
        currencyCodeBuy: "",
        currencyCodeSell: "",
        adultBuy1: 0,
        adultSell1: 0,
        id: null
      },
      headers: [
        {
          text: "Date From",
          align: "right",
          value: "node.dateFrom",
          name: "dateFrom",
          sort: sortByDate
        },
        {
          text: "Date To",
          align: "right",
          value: "node.dateTo",
          name: "dateTo",
          sort: sortByDate
        },
        {
          text: "Rate Type",
          align: "right",
          value: "node.rateTypeCode",
          name: "rateTypeCode"
        },
        {
          text: "Currency Buy",
          align: "right",
          value: "node.currencyCodeBuy",
          name: "currencyCodeBuy"
        },
        {
          text: "Cost",
          align: "right",
          value: "node.adultBuy1",
          name: "adultBuy1"
        },
        {
          text: "Currency Sell",
          align: "right",
          value: "node.currencyCodeSell",
          name: "currencyCodeSell"
        },
        {
          text: "Sell",
          align: "right",
          value: "node.adultSell1",
          name: "adultSell1"
        },
        {
          text: "Actions",
          align: "right",
          value: "",
          sortable: false,
          name: "actions"
        }
      ]
    };
  },

  watch: {
    servicePriceEditorDialog(val) {
      val || this.close();
    }
  },

  computed: {
    formTitle() {
      let title = "Service Prices";
      if (this.service) {
        title = `${this.service.name} - Prices`;
      }
      return title;
    },
    serviceId() {
      return this.service.id;
    }
  },
  methods: {
    onRemovePrice(price) {
      this.$apollo
        .mutate({
          mutation: SERVICE_PRICE_DELETE_MUTATION,
          variables: { priceId: price.node.id },
          update: (store, { data: { deleteServicePrice } }) => {
            // get cache
            const data = store.readQuery({
              query: ALL_SERVICE_PRICES_QUERY,
              variables: { serviceId: this.serviceId }
            });
            //remove price from list
            data.servicePrices.edges = data.servicePrices.edges.filter(
              price => price.node.id !== deleteServicePrice.id
            );
            //update cache
            store.writeQuery({
              query: ALL_SERVICE_PRICES_QUERY,
              variables: { serviceId: this.serviceId },
              data
            });
          }
        })
        .then(result => {
          this.onSuccessMutation("Price Removed.");
        });
    },
    editPrice(data) {
      this.selectedPrice = Object.assign({}, data.node);
      this.servicePriceEditorDialog = true;
    },
    onPriceEditCancel(data) {
      this.servicePriceEditorDialog = false;
    },
    onPriceEditSave(data) {
      if (data.id) {
        //update existing price
        this.updatePrice(data);
      } else {
        //create price
        this.createPrice(data);
      }
    },
    updatePrice(data) {
      this.$apollo
        .mutate({
          mutation: SERVICE_PRICE_UPDATE_MUTATION,
          variables: data
        })
        .then(result => {
          //console.log('mutation result',result);
          this.onSuccessMutation("Price Updated.");
          this.servicePriceEditorDialog = false;
        });
    },
    onSuccessMutation(msg) {
      this.$store.dispatch("showAppSnackbar", { msg });
      EventBus.$emit("refetch-supplier-rates");
    },
    createPrice(data) {
      this.$apollo
        .mutate({
          mutation: SERVICE_PRICE_CREATE_MUTATION,
          variables: { ...data, serviceId: this.serviceId },
          update: (store, { data: { createServicePrice } }) => {
            // get cache
            let data = store.readQuery({
              query: ALL_SERVICE_PRICES_QUERY,
              variables: { serviceId: this.serviceId }
            });
            //add to current cache data
            data.servicePrices.edges.push({
              node: createServicePrice,
              __typename: "PriceEdge"
            });
            store.writeQuery({
              query: ALL_SERVICE_PRICES_QUERY,
              variables: { serviceId: this.serviceId },
              data
            });
          }
        })
        .then(result => {
          this.servicePriceEditorDialog = false;
          this.onSuccessMutation("Price Created");
        });
    },
    close() {
      this.servicePriceEditorDialog = false;
      setTimeout(() => {
        this.selectedPrice = Object.assign({}, this.defaultPrice);
      }, 300);
    },
    refetchServicePrices() {
      if (this.$apollo.queries.servicePrices != null) {
        this.$apollo.queries.servicePrices.refetch();
      }
    }
  },
  mounted() {
    EventBus.$on("refetch-supplier-rates", () => {
      this.refetchServicePrices();
    });
  },
  apollo: {
    servicePrices: {
      query: ALL_SERVICE_PRICES_QUERY,
      variables() {
        return {
          serviceId: this.serviceId
        };
      },
      result({ data, loader, networkStatus }) {
        // console.log(data);
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/services/prices/ServicePriceList.vue